// extracted by mini-css-extract-plugin
export default {"colorButton":"ColorButton_colorButton__StWeQ"};